<template>
  <v-card flat>
    <v-card-text style="padding: 0px;margin: 0px;">
      <v-layout row wrap :class="edoClassName + tableName + ' ' + edoClassName + ' ma-0 pa-0'">
        <v-flex md12 class="ma-2 pa-0">
          <FixedTableIE :key="myKey" :heightSub="subHeight" :widthSub="subWidth" :ankerBank="bankAnchor" ref="crTable"
                        :currency="currentCurrency"
                        :selected="selected" :tableConfig='tableConfig' class="colorrows"
                        :tableNotComplete="tableNotComplete" :headers="headers" :items="pgresults"></FixedTableIE>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
  import Vue from 'vue'
  import FixedTableIE from './../../tables/EasyTableIE'

  export default {
    name: 'ConfigurationTable',
    components: {FixedTableIE},
    props: ['data', 'tableName', 'edoClassName', 'heightSub', 'allTablesData', 'widthSub'],
    methods: {
      openTable: function () {
        Vue.prototype.$api.debug('open table', this.pgresults)
        if (this.$refs.crTable && this.$refs.crTable.updateData) {
          this.$refs.crTable.updateData(this.pgresults, true, Vue.prototype.$api.hideIdle)
        } else {
          Vue.prototype.$api.hideIdle()
        }

      },
      onClearFilter: function () {
        this.$refs.crTable.filterWithString('')
      },
      onEnterFilter: function (sData) {
        this.search = sData
        Vue.prototype.$api.debug('filter', this.search)
        this.$refs.crTable.filterWithString(this.search)
      },
      update: function () {
        Vue.prototype.$api.debug('update table', this.pgresults, this.$refs.sdTable)
        if (this.$refs.sdTable && this.$refs.sdTable.updateData) {
          Vue.prototype.$api.debug('update done')
          this.$refs.crTable.updateData(this.pgresults, true, Vue.prototype.$api.hideIdle)
        }
      },
      getAll: function () {
        return this.$refs.crTable.getAll()
      },
      open: function (XallTablesData) {
        this.tableData = XallTablesData
        this.result = Vue.prototype.$api.prepareWaimeaTable(this.tableData)

        this.pgresults = this.result.rows
        this.headers = this.result.headers
        Vue.prototype.$api.debug('pgresults', this.pgresults[1])
        window.setTimeout(this.openTable, 100)
      },
      close: function () {
        Vue.prototype.$api.showIdle()
        Vue.prototype.$api.debug('close table')
        if (this.$refs.crTable && this.$refs.crTable.doDestroyTable) {
          Vue.prototype.$api.debug('close table done')
          this.$refs.crTable.doDestroyTable()
          this.myKey++
          Vue.prototype.$api.hideIdle()
        }
      }
    },
    data() {
      return {
        pgresults: [],
        bankAnchor: null,
        currentCurrency: '1',
        search: '',
        selected: null,
        tableNotComplete: false,
        myKey: 0,
        widthSubSet: 660,
        subHeight: 180,
        subWidth: 100,
        headers: [],
        result: null,
        'tableConfig': {
          selection: true,
          header: {
            columnClass: 'verlauf abstandunten04 theme--light blue tableIEPadding1 headcolumn'
          },
          rows: {
            rowClass: 'rowEIE'
          }
        }
      }
    },
    mounted() {
      if (this.widthSub) {
        // this.subWidth = (this.subWidth * 1) + (this.widthSub * 1)
      }
      if (this.heightSub) {
        this.subHeight = (this.heightSub * 1) + (this.subHeight * 1)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/module/akte/ConfigurationTable.vue